import { useMutation } from '@tanstack/react-query';
import { patchCreditMemoMode } from '../../Services/ProcessedTimesheetService';

const usePatchCreditMemoMode = (options = {}) => useMutation(patchCreditMemoMode, options);

export default usePatchCreditMemoMode;
